import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { getCustomer } from "../../reducer";
import EditCustomer from "./EditCustomer";
import { Creators as DataCreators } from "../../../data/reducer";

const enhance = compose(
  withRouter,
  connect(
    (state, ownedProps) => ({
      customer: getCustomer(state, ownedProps.match.params.customerId)
    }),
    dispatch => ({
      loadCustomer: customerId =>
        dispatch(DataCreators.loadPath(`customers/${customerId}`))
    })
  )
);
export default enhance(EditCustomer);



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/index.js